import { render } from "./About.vue?vue&type=template&id=4f1a6680"
const script = {}
script.render = render

export default script